import React from 'react';
import { Waypoint } from 'react-waypoint';

import ProductShortInfo from '../product-short-info/ProductShortInfo';

import useStyles from './styles';

const GeneralAccommodationsList = ({ accommodations, page, fetchData, perPage, selectProduct, initialSelectedCurrency }) => {
  const classes = useStyles();

  if (!accommodations?.length) return null;

  return (
    <div className={classes.wrapper}>
      {accommodations.map((item, index) => (
        <div className={classes.item} key={index}>
          <div>
            <ProductShortInfo
              item={item}
              initialSelectedCurrency={initialSelectedCurrency}
              isPrices={true}
              isRightArrow={true}
              selectProduct={selectProduct}
            />
          </div>
          {(page < perPage) && (index === accommodations.length - 2) && (
            <Waypoint onEnter={() => fetchData(page + 1)} />
          )}
        </div>
      ))}
      <div className={classes.afterElement}>{''}</div>
      <div className={classes.afterElement}>{''}</div>
    </div>
  );
};

export default GeneralAccommodationsList;
